function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M337.89,225.873c-21.191,1.306-49.055,22.477-75.928,34.648c-32.956,14.904-84.235,2.926-84.241,2.926 c7.927-3.715,40.072-11.371,46.543-14.222c34.411-15.134,31.479-46.698,15.095-46.433c-21.64,0.365-34.367,5.68-77.566,11.572 c-32.748,4.449-71.479,2.822-90.055,9.914c-26.223,10.02-68.445,77.412-68.445,77.412l65.293,63.283 c0,0,40.436-39.816,60.1-39.816c44.832,0,46.639-0.617,88.253-2.864c17.709-0.946,21.387-1.673,31.525-5.087 c53.957-18.24,111.883-66.817,112.949-72.664C363.866,231.012,349.065,225.177,337.89,225.873z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.598,180.044c1.799,1.153,4.049,1.333,5.975,0.463c34.951-15.699,70.385-15.699,105.328,0 c1.639,0.722,3.521,0.722,5.161,0c34.946-15.699,70.385-15.699,105.326,0c0.805,0.361,1.695,0.55,2.559,0.55 c1.203,0,2.393-0.343,3.422-1.013c1.783-1.15,2.865-3.132,2.865-5.263V18.455c0-4.282-3.629-5.704-3.746-5.754 C276.745,4.276,257.513,0,238.339,0c-16.865,0-33.785,3.336-50.398,9.876v76.738c0,3.018-2.432,5.464-5.463,5.464 c-3.006,0-5.463-2.446-5.463-5.464V9.876C160.419,3.336,143.501,0,126.632,0C107.466,0,88.226,4.276,69.47,12.701 c-0.113,0.05-3.74,1.911-3.74,5.754v156.326C65.729,176.912,66.807,178.893,68.598,180.044z M78.282,145.092 c15.947-6.306,32.178-9.512,48.35-9.512c18.254,0,36.631,4.085,54.572,12.15c0.803,0.36,1.748,0.36,2.555,0 c17.943-8.065,36.318-12.15,54.58-12.15c16.164,0,32.396,3.206,48.338,9.512v20.295c-16.148-6.085-32.578-9.16-48.973-9.16 c-18.52,0-37.088,3.927-55.227,11.702c-18.129-7.776-36.697-11.702-55.227-11.702c-16.391,0-32.816,3.076-48.969,9.161 L78.282,145.092L78.282,145.092z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgHandHoldingUpABook = function SvgHandHoldingUpABook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "364.975px",
    height: "364.975px",
    viewBox: "0 0 364.975 364.975",
    style: {
      enableBackground: "new 0 0 364.975 364.975"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHandHoldingUpABook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hand-holding-up-a-book.223e7d7d.svg";
export { ForwardRef as ReactComponent };